import React from 'react';

import { getErrorMessageFromError } from '../../utils/error';

export interface ErrorTextProps {
  error: any;
}

export const ErrorText: React.FC<ErrorTextProps> = (props) => {
  const { error } = props;

  const errorText = getErrorMessageFromError(error);

  return <div className="font-medium my-4 text-red-600">{errorText}</div>;
};
